import React, { ReactNode } from 'react';
import DropdownClickableItem from '../Dropdown/DropdownClickableItem';
import DropdownItem from '../Dropdown/DropdownItem';
import { useAnalytics } from '../AnalyticsProvider/AnalyticsProvider';
import SettingsIcon from '../Icons/SettingsIcon';
import { ExitThinIcon } from '../Icons/ExitThinIcon';
import { getTerritorySettingsPageUrl } from '../../services/pagesUrl/getTerritorySettingsPageUrl';
import { TerritorySettingsSubpage } from '../TerritorySettings/constants';
import { useTerritoryHomePageContext } from '../TerritoryHomePageContext/TerritoryHomePageContextProvider';
import { TerritoryVersionType } from '../../layouts/TerritoryPageLayout/TerritoryPageLayout';
import { ShieldIcon } from '../Icons/ShieldIcon';
import { getTerritoryManageMembershipPageUrl } from '../../services/pagesUrl/getTerritoryManageMembershipPageUrl';

type TTerritoryMembershipDropdownMenuProps = {
  onLeaveTerritoryButtonClick: () => void;
  territoryId: string;
  isTerritoryMember: boolean;
  isTerritoryAdmin: boolean;
  canUpdateTerritory: boolean;
  territorySlug: string;
};

const TerritoryMembershipDropdownMenu = ({
  onLeaveTerritoryButtonClick,
  territoryId,
  isTerritoryMember,
  isTerritoryAdmin,
  canUpdateTerritory,
  territorySlug,
}: TTerritoryMembershipDropdownMenuProps) => {
  const { sendEvent } = useAnalytics();
  const { territoryVersion } = useTerritoryHomePageContext();

  const buttons: Array<{
    name: string;
    text: string;
    onClick?: () => void;
    show: boolean;
    icon: ReactNode;
    type: 'link' | 'button';
    href?: string;
  }> = [
    {
      name: 'manage_territory',
      text: 'Manage Territory',
      show: canUpdateTerritory,
      icon: <SettingsIcon className="w-4 h-4 md:w-6 md:h-6" />,
      type: 'link',
      href: getTerritorySettingsPageUrl(territorySlug, TerritorySettingsSubpage.overview),
    },
    {
      name: 'leave_territory',
      text: 'Leave Territory',
      onClick: onLeaveTerritoryButtonClick,
      show: territoryVersion !== TerritoryVersionType.V2 && (isTerritoryMember || isTerritoryAdmin),
      icon: <ExitThinIcon className="w-4 h-4 md:w-6 md:h-6" />,
      type: 'button',
    },
    {
      name: 'manage_membership',
      text: 'Manage My Membership Roles',
      show: true,
      icon: <ShieldIcon className="w-4 h-4 md:w-6 md:h-6" />,
      type: 'link',
      href: getTerritoryManageMembershipPageUrl(territorySlug),
    },
  ];

  return (
    <>
      {buttons
        .filter(({ show }) => show)
        .map(({ text, onClick, name, icon, type, href }) => {
          const onClickWithAnalytics = () => {
            sendEvent('territory_membership_dropdown_item_click', { item_name: name, territory_id: territoryId });
            onClick?.();
          };

          return (
            <DropdownItem key={text} className="w-full">
              <DropdownClickableItem
                leftAdornment={icon}
                className="w-full"
                onClick={onClickWithAnalytics}
                type={type}
                href={href}
              >
                {text}
              </DropdownClickableItem>
            </DropdownItem>
          );
        })}
    </>
  );
};

export default TerritoryMembershipDropdownMenu;
